import clothesData from "./traits/clothes.json";
import shoesData from "./traits/shoes.json";
import handToolsData from "./traits/hand-tools.json";
import glovesData from "./traits/gloves.json";
import hairData from "./traits/hair.json";
import hatData from "./traits/hat.json";
import faceHairData from "./traits/face-hair.json";
import glassesData from "./traits/glasses.json";
import React, {useState} from "react";
import FarmerImage from "./FarmerImage";

function random(min: number, max: number) { // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min)
}

interface Randomized {
    clothes: number;
    shoes: number;
    handTools: number;
    gloves: number;
    hair: number;
    hat: number;
    faceHair: number;
    glasses: number;
}

function RandomFarmers() {
    const [dataSet, setDataSet] = useState<Randomized[]>([]);


    const genRandom = () => {
        const clothes = random(0, clothesData[clothesData.length - 1].id);
        const shoes = random(0, clothesData[shoesData.length - 1].id);
        const handTools = random(0, clothesData[handToolsData.length - 1].id);
        const gloves = random(0, clothesData[glovesData.length - 1].id);
        const hair = random(0, clothesData[hairData.length - 1].id);
        const hat = random(0, clothesData[hatData.length - 1].id);
        const faceHair = random(0, clothesData[faceHairData.length - 1].id);
        const glasses = random(0, clothesData[glassesData.length - 1].id);

        return {
            clothes,
            shoes,
            handTools,
            gloves,
            hair,
            hat,
            faceHair,
            glasses
        }
    }

    const genRandomAll = () => {
        const randomData: Randomized[] = [];
        for (let x = 0; x < 21; x++) {
            randomData.push(genRandom())
        }

        setDataSet(randomData);
    }

    return (
        <div className="random-farmers">
            <h3>Random Farmers</h3>
            <button className="btn btn-primary" onClick={genRandomAll}>Generate 20 farmers</button>

            {dataSet.length > 0 &&
            <div className="data-grid">
                {dataSet.map(x => {
                    return <FarmerImage width="300px" height="300px" {...x}/>
                })}
            </div>
            }
        </div>
    );
}

export default RandomFarmers;
